import { Alert, Grid } from "@mui/material";
import DatePicker from "@poseidon/ui/components/form/DatePicker";
import { FormikAutocomplete } from "@poseidon/ui/components/form/FormikAutocomplete";
import { FullWidthField } from "@poseidon/ui/components/form/FullWidthField";
import { Field } from "formik";
import config from "../../config.json";
import { EditSailorFormPanel } from "./EditSailorFormPanel";
import { useMemo } from "react";
import * as Yup from "yup";

const sailorDefaults = {
  email: "",
  title: "",
  firstName: "",
  middleNames: "",
  lastName: "",
  display_name: "",
  phone_number: "",
  mobileNumber: "",
  dateOfBirth: null,
  disabilitiesDescription: "",
};

export const validationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  firstName: Yup.string().min(1).max(15).required("First name is required"),
  middleNames: Yup.string().max(60),
  lastName: Yup.string().min(1).max(30).required("Last name is required"),
  dateOfBirth: Yup.string().required("Date of birth is required"),
  phone_number: Yup.string().optional(),
  mobileNumber: Yup.string().required("Mobile number is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  disabilitiesDescription: Yup.string().optional(),
});
const mapValues = (values) => {
  let dateOfBirth = values.dateOfBirth;

  if (dateOfBirth && dateOfBirth instanceof Date) {
    dateOfBirth = `${dateOfBirth.getFullYear()}-${(dateOfBirth.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${dateOfBirth.getDate().toString().padStart(2, "0")}`;
  }
  console.log(dateOfBirth);
  return {
    ...values,
    dateOfBirth,
  };
};
export function BasicDetailFields({ sailor, disabled }) {
  const initialValues = useMemo(
    () => ({
      ...sailorDefaults,
      ...sailor,
    }),
    [sailor]
  );
  return (
    <EditSailorFormPanel
      title="Basic Details"
      disabled={disabled}
      initialValues={initialValues}
      mapValues={mapValues}
      validationSchema={validationSchema}
      sailor={sailor}
    >
      {sailor.existingCustomer && (
        <Alert color="info" sx={{ width: 1, mb: 2 }}>
          Existing customer
        </Alert>
      )}
      <Grid container spacing={2} mt={0}>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="sailorNumber"
            label="Sailor Number"
            disabled={true}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            component={FormikAutocomplete}
            fullWidth={true}
            label="Title"
            name="title"
            options={config.titles}
            textFieldProps={{
              fullWidth: true,
              variant: "outlined",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="firstName"
            label="First Name"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="middleNames"
            label="Middle Name(s)"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field component={FullWidthField} name="lastName" label="Last Name" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            component={DatePicker}
            name="dateOfBirth"
            label="Date Of Birth"
            margin="none"
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="mobileNumber"
            label="Mobile Number"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="phone_number"
            label="Phone Number"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field component={FullWidthField} name="email" label="Email" />
        </Grid>
        <Grid item xs={12}>
          <Field
            component={FullWidthField}
            name="disabilitiesDescription"
            label="Disabilities (Sailor Declared)"
          />
        </Grid>
      </Grid>
    </EditSailorFormPanel>
  );
}
